import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import NavRowPrimary from '~/components/Layout/Header/Shared/NavRowPrimary';
import NavRowSecondary from '~/components/Layout/Header/Shared/NavRowSecondary';
import NavRowTopSI from '~/components/Layout/Header/Shared/NavRowTopSI';
import NavRowPrimarySI from '~/components/Layout/Header/Shared/NavRowPrimarySI';
import NavRowTertiarySI from '~/components/Layout/Header/Shared/NavRowTertiarySI';
import { setStoreItem } from '~/utilities/Store';
import { LAST_LOADED } from '~/constants/LAST_LOADED';
import { useIsSI } from '~/utilities/useIsSI';
import { AppDataContext } from '~/contexts/AppDataContext';
import { GoogleAuth } from './Shared/GoogleAuth';

/**
 * Builds header areas with multiple nav rows
 *
 * Component Hierarchy:
 *
 * This
 * - NavRowPrimary/Secondary
 * - - Nav
 * - - - NavItem
 * - - - - NavItemLink
 * - - - - NavItemDropdown
 * - - MobileNav
 * - - - MobileNavItem
 * - - - - MobileNavItemLink
 * - - - - MobileNavItemDropdown
 */
export default component$((): JSX.Element => {
  setStoreItem(LAST_LOADED, 'Header');
  const isSI = useIsSI();
  const {
    payloadToSSR: { layout, experiments },
  } = useContext(AppDataContext);
  const hasGoogleAuthExperiment = experiments?.includes('google-oauth-fs');

  return (
    <header>
      {hasGoogleAuthExperiment && <GoogleAuth />}
      {isSI && <NavRowTopSI />}
      {isSI && <NavRowPrimarySI />}
      {!isSI && <NavRowPrimary />}
      {!isSI && <NavRowSecondary />}
      {layout.thirdHeader && <NavRowTertiarySI />}
    </header>
  );
});
